// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start();
require("turbolinks").start();
require("@rails/activestorage").start();
require("channels");
require("@fortawesome/fontawesome");

import $ from 'jquery';
global.$ = jQuery;
global.jQuery = jQuery;

import "/tmp/build_6e0399b7/vendor/bundle/ruby/3.1.0/gems/cocoon-1.2.15/app/assets/javascripts/cocoon";
import "./bootstrap_custom.js";
import "controllers";

require("flatpickr")
import flatpickr from "flatpickr";
import ahoy from "ahoy.js";
import "./dashkit.js";
import blockUI from "jquery-blockui/jquery.blockUI.js";
import select2 from "select2";
